import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CheckCircle2, XCircle, ChevronDown, ChevronUp } from "lucide-react";

// WHICH KINDS OF FILE BULK UPLOAD TAKES — only the kinds whose reader has passed. A kind that has not
// passed is refused here with the plain reason, and goes on one truck at a time from the truck page.
export const BulkGate = () => {
  const [kinds, setKinds] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/bulk-upload/gate").then(({ data }) => setKinds(data.kinds || [])).catch(() => {}); }, []);
  const taken = kinds.filter((k) => k.passed).length;
  return (
    <div data-testid="bulk-gate" className="rounded-xl border border-slate-200 bg-white">
      <button type="button" data-testid="bulk-gate-toggle" onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-2 px-4 py-3 text-left min-h-[44px]">
        <span data-testid="bulk-gate-summary" className="text-sm font-semibold text-slate-800 flex-1">
          What Bulk Upload takes — {taken} of {kinds.length} kinds of file
        </span>
        {open ? <ChevronUp className="w-4 h-4 text-slate-400" /> : <ChevronDown className="w-4 h-4 text-slate-400" />}
      </button>
      {open && (
        <div className="divide-y divide-slate-100 border-t border-slate-100">
          {kinds.map((k) => (
            <div key={k.id} data-testid={`bulk-gate-row-${k.id}`} className="flex items-start gap-2 px-4 py-2">
              {k.passed ? <CheckCircle2 className="w-4 h-4 mt-0.5 text-emerald-600 shrink-0" /> : <XCircle className="w-4 h-4 mt-0.5 text-slate-400 shrink-0" />}
              <div className="min-w-0">
                <div className="text-sm text-slate-800"><b>{k.label}</b> — <span data-testid={`bulk-gate-status-${k.id}`}>{k.passed ? "taken" : "not taken in bulk"}</span></div>
                <div data-testid={`bulk-gate-why-${k.id}`} className="text-[12px] text-slate-500">{k.why}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
